module.exports = __webpack_public_path__ + "img/hiperindex-admin.58bacaf6.jpg";